import { render, staticRenderFns } from "./BannerSettingsView.vue?vue&type=template&id=49b3b88c&scoped=true"
import script from "./BannerSettingsView.vue?vue&type=script&lang=js"
export * from "./BannerSettingsView.vue?vue&type=script&lang=js"
import style0 from "./BannerSettingsView.vue?vue&type=style&index=0&id=49b3b88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3b88c",
  null
  
)

export default component.exports